import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Text,
    Link,
    IconButton,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ErrorIcon, CustomClose} from '../icons'

const GlobalErrorCallout = ({
    label,
    message,
    linkText,
    linkHref,
    onLinkClick,
    showCloseButton = true,
    onClose,
    closeAriaLabel = 'Close error message',
    ...rest
}) => {
    const styles = useMultiStyleConfig('GlobalErrorCallout', {})
    const [isVisible, setIsVisible] = useState(true)

    const handleClose = () => {
        setIsVisible(false)
        onClose?.()
    }

    if (!isVisible) {
        return null
    }

    return (
        <Box {...styles.container} data-testid="global-error-callout" {...rest}>
            <Flex {...styles.header}>
                <Flex {...styles.titleRow}>
                    <ErrorIcon {...styles.icon} />
                    {label && <Text {...styles.label}>{label}</Text>}
                </Flex>
                {showCloseButton && (
                    <IconButton
                        {...styles.closeButton}
                        icon={<CustomClose {...styles.closeIcon} />}
                        aria-label={closeAriaLabel}
                        onClick={handleClose}
                    />
                )}
            </Flex>
            {(message || linkText) && (
                <Box {...styles.body} {...styles.message}>
                    <Text as="span" {...styles.message}>
                        {message}
                        {linkText && (
                            <>
                                {message ? ' ' : ''}
                                <Link
                                    {...styles.linkText}
                                    {...(linkHref ? {href: linkHref} : {})}
                                    onClick={onLinkClick}
                                >
                                    <Text as="span" {...styles.linkText}>
                                        {linkText}
                                    </Text>
                                </Link>
                            </>
                        )}
                    </Text>
                </Box>
            )}
        </Box>
    )
}

GlobalErrorCallout.propTypes = {
    label: PropTypes.node,
    message: PropTypes.node,
    linkText: PropTypes.node,
    linkHref: PropTypes.string,
    onLinkClick: PropTypes.func,
    showCloseButton: PropTypes.bool,
    onClose: PropTypes.func,
    closeAriaLabel: PropTypes.string
}

export default GlobalErrorCallout
